import { UniSnackbarProps } from '../components/uni-snackbar/uni-snackbar.model';

export interface UniSnackbarState {
  snackbars: UniSnackbarProps[];
}

export const uniSnackbarInitialState: UniSnackbarState = {
  snackbars: [],
};
